(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/max-favorites-dialog/prescript.js') >= 0) return;  svs.modules.push('/components/casino-react/max-favorites-dialog/prescript.js');

svs = svs || {};
svs.casino_react = svs.casino_react || {};
svs.casino_react.shared = svs.casino_react.shared || {};
svs.casino_react.shared.data = svs.casino_react.shared.data || {};
svs.casino_react.shared.data.maxFavoritesDialog = svs.casino_react.shared.data.maxFavoritesDialog || {
  maxFavorites: 20,
  title: 'Test title',
  message: 'Test message',
  dialogBranding: 'SPORT',
  navAction: {
    title: 'Test action',
    urlMappingKey: 'casinoMyGames'
  }
};


 })(window);